import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roomsContainer", "roomTemplate"]
  
  connect() {
    this.roomIndex = this.getCurrentMaxIndex() + 1
  }

  addRoom() {
    if (this.hasRoomTemplateTarget) {
      const template = this.roomTemplateTarget.content.cloneNode(true)
      this.roomsContainerTarget.appendChild(template)
      this.roomIndex++
    }
    document.dispatchEvent(new CustomEvent('room:update'))
  }

  removeRoom(event) {
    const roomCard = event.currentTarget.closest('[data-room-index]')
    if (roomCard) {
      roomCard.remove()
    }
    document.dispatchEvent(new CustomEvent('room:update'))
  }

  getCurrentMaxIndex() {
    const roomCards = this.roomsContainerTarget.querySelectorAll('[data-room-index]')
    let maxIndex = -1
    
    roomCards.forEach(card => {
      const index = parseInt(card.dataset.roomIndex)
      if (!isNaN(index) && index > maxIndex) {
        maxIndex = index
      }
    })
    
    return maxIndex
  }


  replacePlaceholders(element, placeholder, value) {
    // Replace in text content
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    )
    
    let node
    while (node = walker.nextNode()) {
      if (node.textContent.includes(placeholder)) {
        node.textContent = node.textContent.replace(new RegExp(placeholder, 'g'), value)
      }
    }
    
    // Replace in attributes
    const allElements = element.querySelectorAll('*')
    allElements.forEach(el => {
      Array.from(el.attributes).forEach(attr => {
        if (attr.value.includes(placeholder)) {
          attr.value = attr.value.replace(new RegExp(placeholder, 'g'), value)
        }
      })
    })
    
    // Also check the root element if it's not a document fragment
    if (element.nodeType === Node.ELEMENT_NODE) {
      Array.from(element.attributes).forEach(attr => {
        if (attr.value.includes(placeholder)) {
          attr.value = attr.value.replace(new RegExp(placeholder, 'g'), value)
        }
      })
    }
  }
}